import { Stage } from 'application/stage'
import { Form as FormComponent } from 'features/form/components'
import { FormProps } from 'features/form/types'
import React, { createContext, useContext, useState } from 'react'
import { Cell, Container, Row } from 'ui/grid'

import { useSingleCarSmartContractAPI } from '../../features/smart-contract/detail/useSingleCarSmartContractAPI'

const formContext = createContext<FormProps>({} as FormProps)

export const useFormConfig = () => useContext(formContext)

export const FormContextProvider = formContext.Provider

export const Form: Stage<FormProps> = React.memo((props) => {
  const { formsWillBeReplaced } = useSingleCarSmartContractAPI()
  const [sent, setSent] = useState<boolean>(false)

  return (
    <Container>
      <Row justifyContent={'center'}>
        <Cell size={12} tablet={6}>
          <FormContextProvider value={props}>
            <FormComponent skipRender={formsWillBeReplaced} sent={sent} setSent={setSent} />
          </FormContextProvider>
        </Cell>
      </Row>
    </Container>
  )
})

export default Form
